/**
 * Error and display string constants for the doc-engine.
 *
 * These are inline document labels rendered inside error/fallback spans
 * within document content. Convention: no trailing period, no exclamation
 * mark - they're inline labels, not toast messages.
 *
 * Values match TERMINOLOGY constants from @shared/i18n
 * (the engine cannot import them directly - zero product imports).
 */

// Inline error labels - rendered in ref-error, block-error, inline-block-error spans
export const REFERENCE_LOAD_ERROR = 'Cannot load reference';
export const INLINE_BLOCK_LOAD_ERROR = 'Cannot load reusable snippet';
export const BLOCK_LOAD_ERROR = 'Cannot load reusable content';

/**
 * A block whose registration has not settled - `data-loaded-id` still points at the node it was
 * copied from - is not a broken block, and the editor says so with a placeholder rather than an
 * error. These match its wording exactly, ellipsis included, because a renderer outside the editor
 * exists to reproduce what the editor shows.
 */
export const BLOCK_NOT_LOADED = 'Loading reusable content...';
export const INLINE_BLOCK_NOT_LOADED = 'Loading reusable snippet...';

// Fallback text when referenced data no longer exists
export const DELETED_SECTION_FALLBACK = 'Deleted section';

/** The editor's block wrapper carries these too, so both drawings resolve the same css rules. */
export const BLOCK_WRAPPER_CLASS = 'reusable-block block-styled static-content';

// The inner div is structural: `.block-styled > div > :last-child` resets the bottom margin.
export const wrapStaticBlock = (header: string, content: string): string =>
  `<div class="${BLOCK_WRAPPER_CLASS}">${header}<div>${content}</div></div>`;
